"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGroundAnnotationSchema = exports.IPowerAnnotationSchema = exports.PowerInferenceSourceSchema = exports.IPowerInferenceSourceErcNetTypePowerSchema = exports.IPowerInferenceSourceOutputPowerPinsSchema = exports.IPowerInferenceSourceInputPowerPinsSchema = exports.IPowerInferenceSourceNetNameSchema = exports.IPowerInferenceSourceSupplySymbolSchema = void 0;
const zod_1 = require("zod");
const DesignModels_1 = require("../../DesignModels");
const NetAnnotationType_1 = require("../NetAnnotationType");
exports.IPowerInferenceSourceSupplySymbolSchema = zod_1.default.object({
    type: zod_1.default.literal('supply-symbol'),
    id: zod_1.default.string(),
    value: zod_1.default.number().nullable(),
});
exports.IPowerInferenceSourceNetNameSchema = zod_1.default.object({
    type: zod_1.default.literal('net-name'),
    value: zod_1.default.number().nullable(),
});
exports.IPowerInferenceSourceInputPowerPinsSchema = zod_1.default.object({
    type: zod_1.default.literal('fed-power-pins'),
    pins: DesignModels_1.NetConnectionSchema.array(),
});
exports.IPowerInferenceSourceOutputPowerPinsSchema = zod_1.default.object({
    type: zod_1.default.literal('output-power-pins'),
    pins: DesignModels_1.NetConnectionSchema.array(),
});
exports.IPowerInferenceSourceErcNetTypePowerSchema = zod_1.default.object({
    type: zod_1.default.literal('erc-net-type-power'),
});
exports.PowerInferenceSourceSchema = zod_1.default.discriminatedUnion('type', [
    exports.IPowerInferenceSourceSupplySymbolSchema,
    exports.IPowerInferenceSourceNetNameSchema,
    exports.IPowerInferenceSourceInputPowerPinsSchema,
    exports.IPowerInferenceSourceOutputPowerPinsSchema,
    exports.IPowerInferenceSourceErcNetTypePowerSchema,
]);
exports.IPowerAnnotationSchema = zod_1.default.object({
    net: zod_1.default.string(),
    type: zod_1.default.literal(NetAnnotationType_1.NetAnnotationType.Power),
    inferenceSources: exports.PowerInferenceSourceSchema.array(),
});
exports.IGroundAnnotationSchema = zod_1.default.object({
    net: zod_1.default.string(),
    type: zod_1.default.literal(NetAnnotationType_1.NetAnnotationType.Ground),
    inferenceSources: exports.PowerInferenceSourceSchema.array(),
});
//# sourceMappingURL=NetPowerAnnotationType.js.map